import { useTheme } from '@emotion/react';
import React from 'react';

import { Alert, Text } from '~/components/blocks';

// 本部側・店舗側の店舗設定ドロワーで同じ理由を示すため partial に置く
export const YakumaruGroupCodeUnsetAlert = () => {
  const theme = useTheme();

  return (
    <Alert status="warning" marginY={theme.space.m}>
      <Text size="s">法人IDが未設定のため、店舗IDでの連携は選択できません</Text>
    </Alert>
  );
};
